// Derive a draft's filename from the markdown if possible.
// If line 1 is an H1 (eg `# Title`), use the title; otherwise fall back to "Untitled".
const deriveDraftName = (md: string): string => {
  const firstLine = md.split('\n', 1)[0] ?? '';
  const match = firstLine.match(/^#\s+(.+?)\s*$/);
  const title = match?.[1].trim();
  return title ? `${title}.md` : 'Untitled.md';
};

export default deriveDraftName;
